import {useIntercom} from 'react-use-intercom/dist/index.js'

export const useIntercomIntegration = () => {
    const {update, boot} = useIntercom()

    const bootIntercom = () => {
        boot()
    }

    const updateData = (user) => {
        const {firstname, email, accountKey, plannerMaskedPan, ...attributes} =
            user

        const additionalData = {
            reportsCount: 0,
            isSubscribed: true,
            ccDigits: plannerMaskedPan?.trim().slice(-4),
            source: 'admin',
            domain: 'planners',
        }

        const userId = `plannerAgent_${accountKey}`
        update({
            alignment: 'left',
            email,
            userId,
            name: firstname,
            customAttributes: {...attributes, ...additionalData},
        })
    }

    return {updateData, bootIntercom}
}
